if ($("#case-studies-map").length != 0) {
	// Define array of markers
	var markers = [];
	var locationData;

	// Get locationData
	$.ajax({ url: 'api/case-studies-map/' }).done(function (data) {
		locationData = jQuery.parseJSON(data);
		initialize(locationData);
	});

	// Clicked on a development icon
	function showDevelopment(i) {
		google.maps.event.trigger(markers[i], 'click');
	}

	// Init gmap
	function initialize(locations) {
		var zoom = 8;
		var center = new google.maps.LatLng(52.100410, -0.286479);

		// Create new map
		var map = new google.maps.Map(document.getElementById('map'), {
			zoom: zoom,
			center: center,
			mapTypeControl: false,
			mapTypeControlOptions: { style: google.maps.MapTypeControlStyle.DROPDOWN_MENU },
			navigationControl: true,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			draggable: true,
			scrollwheel: false
		});

		// Define marker + counter
		var marker, i;

		// Define map bounds
		//var bounds = new google.maps.LatLngBounds();

		// Loop through each location
		for (i = 0; i < locations.length; i++) {
			// Define location's position
			var position = new google.maps.LatLng(locations[i]['coords']['lat'], locations[i]['coords']['lng']);

			// Set icon

			// Add marker to map at new position
			marker = new google.maps.Marker({
				map: map,
				icon: 'http://zerocool.meloncreative.co.uk/christian/boa-2019/assets/images/case-study-map-pin.png',
				draggable: false,
				position: position,
				visible: true,
				animation: google.maps.Animation.DROP,
			});

			// Add this location's marker to markers array
			markers.push(marker);

			// Extend map bounds to include this location's position
			//bounds.extend(position);

			// Add click event to marker to show infobox
			google.maps.event.addListener(markers[i], 'click', (function (marker, i) {
				return function () {
					// Create markup for infobox
					var boxText = document.createElement("div");
					boxText.innerHTML = locations[i]['tooltip'];

					// Define infowindow
					var infowindow = new google.maps.InfoWindow({
						content: boxText,
						position: position,
						disableAutoPan: true
					});

					// Close any open info windows
					google.maps.event.trigger(map, 'click');

					// Show infowindow for this marker
					infowindow.open(map, marker);

					var panPosition = new google.maps.LatLng(locations[i]['coords']['lat'], locations[i]['coords']['lng']);

					// Pan map to infobox position
					map.panToWithOffset(panPosition, 130, -145);

					// Remove active state from other developments
					$('ul.list-developments li').removeClass('active');
					// Add active class to this development
					$('ul.list-developments li[data-index="' + i + '"]').addClass('active');

					marker.setIcon('../assets/images/case-study-map-pin-rotated.png');

					// Style infowindow
					google.maps.event.addListener(infowindow, 'domready', function () {
						// Reference to the DIV which receives the contents of the infowindow using jQuery
						var iwOuter = $('.gm-style-iw');

						// Remove click events from originally positioned infobox div
						iwOuter.parent().css({ 'pointer-events': 'none' });

						// Set overflow to visible so we can see whole tooltip
						iwOuter.children(':nth-child(1)').css({ 'overflow': 'visible' });

						// Set position for infowindow
						iwOuter.css({ 'width': '270px', 'height': '200px', 'left': '0', 'top': '0' });

						// Set background layer
						var iwBackground = iwOuter.prev();

						// Remove the white background DIV + background shadow DIV
						iwBackground.children(':nth-child(2), :nth-child(4)').css({ 'display': 'none' });

						// Hide close button
						iwOuter.next().hide();

						// Hide arrow + shadow of the arrow
						iwBackground.children(':nth-child(1), :nth-child(3)').hide();
					});

					// Clicked on the map
					google.maps.event.addListener(map, 'click', function () {
						// Close any open infowindows
						infowindow.close();

						marker.setIcon('http://zerocool.meloncreative.co.uk/christian/boa-2019/assets/images/case-study-map-pin.png');
					});
				}
			})(marker, i));
		}

		// Set map to fit bounds to include all locations
		// map.fitBounds(bounds);

		// Map styling
		var styledMapType = new google.maps.StyledMapType(
			[{ "featureType": "administrative", "elementType": "geometry.fill", "stylers": [{ "color": "#d6e2e6" }] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [{ "color": "#cfd4d5" }] }, { "featureType": "administrative", "elementType": "labels.text.fill", "stylers": [{ "color": "#7492a8" }] }, { "featureType": "administrative.neighborhood", "elementType": "labels.text.fill", "stylers": [{ "lightness": 25 }] }, { "featureType": "landscape.man_made", "elementType": "geometry.fill", "stylers": [{ "color": "#dde2e3" }] }, { "featureType": "landscape.man_made", "elementType": "geometry.stroke", "stylers": [{ "color": "#cfd4d5" }] }, { "featureType": "landscape.natural", "elementType": "geometry.fill", "stylers": [{ "color": "#dde2e3" }] }, { "featureType": "landscape.natural", "elementType": "labels.text.fill", "stylers": [{ "color": "#7492a8" }] }, { "featureType": "landscape.natural.terrain", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "poi", "elementType": "geometry.fill", "stylers": [{ "color": "#dde2e3" }] }, { "featureType": "poi", "elementType": "labels.text.fill", "stylers": [{ "color": "#588ca4" }] }, { "featureType": "poi", "elementType": "labels.icon", "stylers": [{ "saturation": -100 }] }, { "featureType": "poi.park", "elementType": "geometry.fill", "stylers": [{ "color": "#a9de83" }] }, { "featureType": "poi.park", "elementType": "geometry.stroke", "stylers": [{ "color": "#bae6a1" }] }, { "featureType": "poi.sports_complex", "elementType": "geometry.fill", "stylers": [{ "color": "#c6e8b3" }] }, { "featureType": "poi.sports_complex", "elementType": "geometry.stroke", "stylers": [{ "color": "#bae6a1" }] }, { "featureType": "road", "elementType": "labels.text.fill", "stylers": [{ "color": "#41626b" }] }, { "featureType": "road", "elementType": "labels.icon", "stylers": [{ "saturation": -45 }, { "lightness": 10 }, { "visibility": "on" }] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [{ "color": "#c1d1d6" }] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "color": "#a6b5bb" }] }, { "featureType": "road.highway", "elementType": "labels.icon", "stylers": [{ "visibility": "on" }] }, { "featureType": "road.highway.controlled_access", "elementType": "geometry.fill", "stylers": [{ "color": "#9fb6bd" }] }, { "featureType": "road.arterial", "elementType": "geometry.fill", "stylers": [{ "color": "#ffffff" }] }, { "featureType": "road.local", "elementType": "geometry.fill", "stylers": [{ "color": "#ffffff" }] }, { "featureType": "transit", "elementType": "labels.icon", "stylers": [{ "saturation": -70 }] }, { "featureType": "transit.line", "elementType": "geometry.fill", "stylers": [{ "color": "#b4cbd4" }] }, { "featureType": "transit.line", "elementType": "labels.text.fill", "stylers": [{ "color": "#588ca4" }] }, { "featureType": "transit.station", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "transit.station", "elementType": "labels.text.fill", "stylers": [{ "color": "#008cb5" }, { "visibility": "on" }] }, { "featureType": "transit.station.airport", "elementType": "geometry.fill", "stylers": [{ "saturation": -100 }, { "lightness": -5 }] }, { "featureType": "water", "elementType": "geometry.fill", "stylers": [{ "color": "#a6cbe3" }] }],
			{ name: 'Styled Map' }
		);

		// associating map with styling
		map.mapTypes.set('styled_map', styledMapType);
		map.setMapTypeId('styled_map');
	}

	// Function for google maps (pan to with offset)
	google.maps.Map.prototype.panToWithOffset = function (latlng, offsetX, offsetY) {
		var map = this;
		var ov = new google.maps.OverlayView();
		ov.onAdd = function () {
			var proj = this.getProjection();
			var aPoint = proj.fromLatLngToContainerPixel(latlng);
			aPoint.x = aPoint.x + offsetX;
			aPoint.y = aPoint.y + offsetY;
			map.panTo(proj.fromContainerPixelToLatLng(aPoint));
		};
		ov.draw = function () { };
		ov.setMap(this);
	};
}